import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { db } from "../../firebase/firebaseconfig"; // Ensure this path is correct
import { collection, query, limit, onSnapshot, orderBy } from "firebase/firestore";
import { LayoutGrid, Mail, Send, ChevronRight } from "lucide-react";

const ProjectSidebar = () => {
  const { projectId } = useParams();
  const [recentProjects, setRecentProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  // --- FETCH RECENT PROJECTS FROM FIREBASE ---
  useEffect(() => {
    // We fetch the 6 most recent projects (in case one is the current project)
    const q = query(
      collection(db, "projects"),
      orderBy("createdAt", "desc"),
      limit(6)
    );

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const projects = [];
      querySnapshot.forEach((doc) => {
        projects.push({ id: doc.id, ...doc.data() });
      });
      setRecentProjects(projects);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return (
    <div className="project-sidebar">
      
      {/* Other Projects Section */}
      <div className="other-projects-section p-4 bg-white rounded-4 mb-4 shadow-sm border-0">
        <div className="d-flex align-items-center mb-4 pb-2 border-bottom border-light">
          <LayoutGrid size={18} className="text-success me-2" />
          <h5 className="mb-0 fw-semibold text-dark">Recent Projects</h5>
        </div>

        <ul className="list-unstyled mb-0">
          {loading ? (
            <li className="text-muted small p-2">Loading projects...</li>
          ) : (
            recentProjects
              .filter(p => p.id !== projectId) // Hide the project the user is currently viewing
              .slice(0, 5) // Show only the top 5
              .map((project) => (
                <li key={project.id} className="mb-2">
                  <Link 
                    to={`/project/${project.id}`} 
                    className="text-decoration-none d-flex align-items-center justify-content-between p-2 rounded-3 transition-all sidebar-link"
                  >
                    <span className="medium text-secondary line-clamp-1">{project.title}</span>
                    <ChevronRight size={14} className="text-muted opacity-50 flex-shrink-0" />
                  </Link>
                </li>
              ))
          )}

          <li className="mt-4 pt-2 text-center">
            <Link to="/project" className="text-success text-decoration-none small fw-medium d-flex align-items-center justify-content-center gap-1">
              View all portfolio <ChevronRight size={14} />
            </Link>
          </li>
        </ul>
      </div>

      {/* Quick Inquiry Form */}
      <div className="quick-inquiry-section p-4 bg-white rounded-4 shadow-sm border-0">
        <div className="d-flex align-items-center mb-4 pb-2 border-bottom border-light">
          <Mail size={18} className="text-success me-2" />
          <h5 className="mb-0 fw-semibold text-dark">Quick Inquiry</h5>
        </div>

        <form>
          <div className="mb-3">
            <label className="small text-muted mb-1 ms-1">Full Name</label>
            <input
              type="text"
              placeholder="Enter your name"
              className="form-control bg-light border-0 px-3 py-2 small rounded-3"
            />
          </div>
          <div className="mb-3">
            <label className="small text-muted mb-1 ms-1">Email Address</label>
            <input
              type="email"
              placeholder="name@example.com"
              className="form-control bg-light border-0 px-3 py-2 small rounded-3"
              required
            />
          </div>
          <div className="mb-3">
            <label className="small text-muted mb-1 ms-1">Message</label>
            <textarea
              rows="4"
              placeholder="How can we help?"
              className="form-control bg-light border-0 px-3 py-2 small rounded-3"
            />
          </div>
          <button type="button" className="btn btn-success w-100 rounded-3 py-2 fw-medium d-flex align-items-center justify-content-center shadow-sm border-0 mt-4">
            <Send size={16} className="me-2" /> Send Inquiry
          </button>
        </form>
      </div>

      <style>{`
        .sidebar-link:hover {
          background-color: #f8f9fa;
          padding-left: 12px !important;
        }
        .line-clamp-1 {
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;  
          overflow: hidden;
        }
      `}</style>
    </div>
  );
};

export default ProjectSidebar;